import { render, staticRenderFns } from "./ContactChannelIcon.vue?vue&type=template&id=1ccc1bdc&"
import script from "./ContactChannelIcon.vue?vue&type=script&lang=js&"
export * from "./ContactChannelIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports